import React from 'react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from '../../components/ui/dialog';
import { Check } from 'lucide-react';
import { CATEGORY_LABEL, ALL_CATEGORIES, isWeightOnly } from './constants';

const ExpectedStoneDialog = ({ open, onOpenChange, form, setForm, editIndex, onSave }) => {
  const weightOnly = isWeightOnly(form?.category);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm max-h-[92vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>{editIndex >= 0 ? 'Edit expected entry' : 'Add expected entry'}</DialogTitle>
          <DialogDescription>
            Diamond / Stone / Beads&nbsp;&amp;&nbsp;Pearls need piece count + weight.
            Dust and Others are weight-only.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label className="text-xs">Category</Label>
            <div className="grid grid-cols-3 gap-2 mt-1">
              {ALL_CATEGORIES.map((c) => (
                <button
                  key={c} type="button"
                  onClick={() => setForm({ ...form, category: c })}
                  className={`h-11 text-xs rounded-lg border transition-colors ${
                    form.category === c
                      ? 'bg-amber-700 text-white border-amber-800'
                      : 'bg-white text-slate-700 border-slate-200 hover:bg-slate-50'
                  }`}
                  data-testid={`exp-entry-cat-${c}`}
                >
                  {CATEGORY_LABEL[c]}
                </button>
              ))}
            </div>
          </div>
          {!weightOnly && (
            <div>
              <Label className="text-xs">Pieces (count)</Label>
              <Input
                type="number" inputMode="numeric" min="0"
                value={form.pcs}
                onChange={(e) => setForm({ ...form, pcs: e.target.value })}
                data-testid="exp-entry-pcs-input"
                className="h-11 text-base"
                autoFocus
              />
            </div>
          )}
          <div>
            <Label className="text-xs">Weight (gm)</Label>
            <Input
              type="number" inputMode="decimal" step="0.001" min="0"
              value={form.wt}
              onChange={(e) => setForm({ ...form, wt: e.target.value })}
              data-testid="exp-entry-wt-input"
              className="h-11 text-base"
              autoFocus={weightOnly}
            />
          </div>
          {weightOnly && (
            <div className="text-[11px] text-slate-500">
              {CATEGORY_LABEL[form.category]} is weight-only — no piece count needed.
            </div>
          )}
        </div>
        <div className="pt-3 flex gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1 h-11">Cancel</Button>
          <Button onClick={onSave} className="flex-1 h-11 bg-amber-700 hover:bg-amber-800" data-testid="exp-entry-save-btn">
            <Check className="w-4 h-4 mr-1" /> Save
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ExpectedStoneDialog;
